import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { submitSupportTicketEndpoint } from '../../../common/endpoints';

export const submitTicketData = createApi(submitSupportTicketEndpoint, 'POST');

const SubmitTicket = createSlice({
  name: 'SubmitTicket',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitTicketData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitTicketData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(submitTicketData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default SubmitTicket.reducer;